import { SlicesUIElement, html } from '../element/element';
import { StringConverter, NumberConverter } from 'html-element-property-mixins/src/utils/attribute-converters';
import '../selector/selector';
import '../button/button';
import { css } from './tab-bar.css.js';

/**
 * 
 * @element slicesui-tab-bar
 * 
 * @fires change - Fires when 'value' changed
 * 
 * @prop {Number} [selectedIndex=-1] - Index of selected item
 * @attr {Number} [selectedindex]
 * 
 * @prop {String} value - Value of selected item
 * @attr {String} value
 * 
 * @cssprop --slicesui-tab-bar-border-radius - Border radius
 * 
 */
class SlicesUITabBar extends SlicesUIElement {

  static get properties() {
    return {
      
      selectedIndex: {
        observe: true,
        DOM: true,
        reflect: true,
        fromAttributeConverter: NumberConverter.fromAttribute,
        toAttributeConverter: NumberConverter.toAttribute,
      },

      value: {
        observe: true,
        DOM: true,
        reflect: true,
        fromAttributeConverter: StringConverter.fromAttribute,
        toAttributeConverter: StringConverter.toAttribute,
        changedHandler: '_dispatchChangeEvent'
      },

    };
  }

  static get propertiesChangedHandlers() {
    return {
      render: ['selectedIndex', 'value']
    };
  }

  constructor() {
    super();
    this._initMutationObserver();
    
  }

  /**
   * @private
   */
  get template() {
    return html`
      <style>${css}</style>
      <nav>
        <slicesui-selector .selectedIndex="${this.selectedIndex}" @change="${this._handleValueChange}"></slicesui-selector>
      </nav>
      <slot @slotchange="${this._updateDOM}" hidden></slot>
    `;
  }

  _initMutationObserver() {
    const targetNode = this;
    const config = { attributes: true, childList: true, subtree: true };
    const observer = new MutationObserver(this._updateDOM.bind(this));
    observer.observe(targetNode, config);
  }

  _updateDOM() {
    this.shadowRoot.querySelector('slicesui-selector').innerHTML = this.innerHTML;
  }

  _handleValueChange(e) {
    this.value = e.target.value;
  }

  _dispatchChangeEvent() {
    const evt = new CustomEvent('change', { detail: {value: this.value} });
    this.dispatchEvent(evt);
  }

}

window.customElements.define('slicesui-tab-bar', SlicesUITabBar);